import React from 'react';

const ToggleSwitch = (props) => {

    return ( 
        <div className="date_toggle_main">
        <div>
          <p>{props.labelLeft}</p>
        </div>
        <div style={props.disabled ? {pointerEvents:'none'} : void 0}>
          <label className="__switch">
            { props.checked === false && props.switch=== false  ?
             (
              <input
                type="checkbox"
                // checked
                value={props.switch}
                onClick={() => props.toggleCallBack()}
              />
            ):
            (
               <input
                type="checkbox"
                checked
                value={props.switch}
                onClick={() => props.toggleCallBack()}
                
              />  
                            
            )
            }
            <span className="__slider __round" style={props.disabled ? {backgroundColor:'#f2f2f2'} : void 0}></span>
          </label>
        </div>
        <div>
          <p>{props.labelRight}</p>
        </div>
      </div>

     );
}
 
export default ToggleSwitch;